import { A, useNavigate } from "@solidjs/router";
import { createMemo, createSignal } from "solid-js";

import { BackIcon, QrCodeIcon, SettingsIcon } from "../components/icons";

function SigninView() {
  const navigate = useNavigate();
  const [nsec, setNsec] = createSignal("");

  const hasExtension = createMemo(() => Reflect.has(window, "nostr"));

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    // Handle signin logic here
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        class="p-4 flex-grow flex flex-col justify-center items-center gap-2"
      >
        <div class="join w-full">
          <input
            type="password"
            value={nsec()}
            onInput={(e) => setNsec(e.currentTarget.value)}
            placeholder="Enter your nsec..."
            class="input input-bordered join-item flex-1"
          />
          <button type="button" class="btn btn-primary join-item" disabled>
            <QrCodeIcon />
          </button>
        </div>
        <button type="submit" class="btn btn-primary w-full">
          Sign In
        </button>
        {hasExtension() && (
          <button type="button" class="btn btn-outline w-full">
            Use Extension
          </button>
        )}
      </form>

      <footer class="flex justify-between p-2 pb-safe-or-2 flex-shrink-0">
        <button
          onClick={() => navigate(-1)}
          class="btn btn-ghost btn-square"
          aria-label="back"
        >
          <BackIcon />
        </button>
        <A
          href="/settings"
          class="btn btn-ghost btn-square"
          aria-label="settings"
        >
          <SettingsIcon />
        </A>
      </footer>
    </>
  );
}

export default SigninView;
